import Slider from "react-slick";
import "./SliderComponent.scss";
import { useEffect, useState } from "react";
import videoIcon from '../assets/images/video-icon.png'
import useFancybox from "../hooks/useFancybox";
import InnerImageZoom from "react-inner-image-zoom";
import "inner-image-zoom/lib/styles.min.css";

export default function SliderComponent ({images, video = null}) {
  const [settings, setSettings] =useState({});
  const [fancyboxRef] = useFancybox({})
  const [imgs, setImgs] = useState([])

  useEffect(()=>{
    let im = []
    images.forEach(element => {
      if (element.preview) {
        im = [...im, {img_thumb: element.preview, img_medium: element.preview, img_large: element.preview}]
      } else {
        im = [...im, {img_thumb: element.imagen+'_thumb.webp', img_medium: element.imagen+'_medium.webp', img_large: element.imagen+'_large.webp'}]
      }
    });
    setImgs(im);
  },[images])



  useEffect(()=>{
    setSettings({
      ...settings,
      customPaging: function(i) {
        return (
          <a>
            {images[i] 
              ? <img src={`${images[i].imagen+'_thumb.webp'}`} />
              : <img src={videoIcon} />
            }
          </a>
        );
      },
      dots: true,
      className: "carousel-prod-amp items-content",
      dotsClass: "slick-thumb",
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    })
  },[images])

  return (
    <>
    {
      imgs.length > 0 ?
      <div className="slider-container">
        {imgs.length == 1 ?
          video
            ?  <Slider {...settings} ref={fancyboxRef}>
                <a
                  data-fancybox="gallery"
                  data-src={imgs[0].img_large}
                >
                  <InnerImageZoom
                    src={imgs[0].img_medium}
                    zoomType="hover"
                    zoomPreload={true}
                  />
                </a>
                <>
                  <a data-fancybox="gallery" href="#video">
                    <div  dangerouslySetInnerHTML={{ __html: video }}></div>
                  </a>
                  <div style={{ display: "none" }}>
                    <div id="video">
                      <div  dangerouslySetInnerHTML={{ __html: video }}></div>
                    </div>
                  </div>
                </>
              </Slider>
            : <div ref={fancyboxRef} >
                <a
                  data-fancybox
                  data-src={imgs[0].img_large}
                  className="slick-slider carousel-prod-amp"
                >
                  <InnerImageZoom
                    src={imgs[0].img_medium}
                    zoomType="hover"
                    zoomPreload={true}
                  />
                </a>
              </div>
          :
          <Slider {...settings} ref={fancyboxRef}>
            {imgs.map((item) => {
              return (
                <a key={`media_${item.id}`}
                  data-fancybox="gallery"
                  data-src={item.img_large}
                >
                <InnerImageZoom
                    src={item.img_medium}
                    zoomType="hover"
                    zoomPreload={true}
                    hasSpacer={true}
                    width={490}
                    height={400}
                  /> 
                </a>
              )
            })}
            {video
              ? <>
                  <a data-fancybox="gallery" href="#video">
                    <div  dangerouslySetInnerHTML={{ __html: video }}></div>
                  </a>
                  <div style={{ display: "none" }}>
                    <div id="video">
                      <div  dangerouslySetInnerHTML={{ __html: video }}></div>
                    </div>
                  </div>
                </>
              : null
            }
          </Slider>
        }
      </div>
      : null
    }
    </>
  )
}